import {getNoAuth} from "../../common/fetchWrapper";


const getAntiFraudScript = async (confirmButtonId) =>{
    return getNoAuth(`/antifraud/script/${confirmButtonId}`)
};

export {
    getAntiFraudScript
}